import { render, staticRenderFns } from "./WorkDetailsDialog.vue?vue&type=template&id=9db683e8&scoped=true"
import script from "./WorkDetailsDialog.vue?vue&type=script&lang=js"
export * from "./WorkDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailsDialog.vue?vue&type=style&index=0&id=9db683e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db683e8",
  null
  
)

export default component.exports